import React from 'react';
import { TitleHeader } from 'web-library';
import CoordinatorResitRegisterComponent from '../../modules/resit/components/@coordinator/CoordinatorResitRegister';

interface CoordinatorResitProps {
  title: string;
}

const CoordinatorResitRegister = ({ title = '' }: CoordinatorResitProps) => (
  <>
    <TitleHeader title={title} />

    <CoordinatorResitRegisterComponent />
  </>
);

export default CoordinatorResitRegister;
